import { MEDICAL_CONDITION_KEYS } from "@./cat-calculations";
import { snakeCaseToCamelCase } from "@utils/misc";
import { useTranslations } from "next-intl";
import { createEnumTranslations } from "./createEnumTranslations";

export const useCatMedicalConditions = () => {
  const tMedicalConditions = useTranslations("Cats.MedicalConditions");
  const tVocabulary = useTranslations("Shared.Vocabulary");
  const unknown = tVocabulary("unknown");

  return createEnumTranslations({
    values: MEDICAL_CONDITION_KEYS,
    translate: (medicalCondition) => (
      tMedicalConditions(snakeCaseToCamelCase(medicalCondition))
    ),
    fallback: unknown,
  });
};
